
    import './styles.scoped.css';
    export default {
  "button-dropdown": "awsui_button-dropdown_sne0l_16ou9_9",
  "full-width": "awsui_full-width_sne0l_16ou9_12",
  "items-list-container": "awsui_items-list-container_sne0l_16ou9_17",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_sne0l_16ou9_1",
  "rotate": "awsui_rotate_sne0l_16ou9_36",
  "rotate-open": "awsui_rotate-open_sne0l_16ou9_50",
  "header": "awsui_header_sne0l_16ou9_54",
  "title": "awsui_title_sne0l_16ou9_65",
  "description": "awsui_description_sne0l_16ou9_66",
  "trigger-button": "awsui_trigger-button_sne0l_16ou9_70",
  "loading": "awsui_loading_sne0l_16ou9_74",
  "split-trigger-wrapper": "awsui_split-trigger-wrapper_sne0l_16ou9_78",
  "trigger-item": "awsui_trigger-item_sne0l_16ou9_81",
  "has-no-text": "awsui_has-no-text_sne0l_16ou9_90",
  "visual-refresh": "awsui_visual-refresh_sne0l_16ou9_93",
  "has-trigger-text": "awsui_has-trigger-text_sne0l_16ou9_104",
  "variant-normal": "awsui_variant-normal_sne0l_16ou9_107",
  "split-trigger": "awsui_split-trigger_sne0l_16ou9_78",
  "dropdown-trigger": "awsui_dropdown-trigger_sne0l_16ou9_118",
  "main-action-full-width": "awsui_main-action-full-width_sne0l_16ou9_122",
  "main-action-trigger-full-width": "awsui_main-action-trigger-full-width_sne0l_16ou9_126",
  "filter": "awsui_filter_sne0l_16ou9_130",
  "test-utils-button-trigger": "awsui_test-utils-button-trigger_sne0l_16ou9_136"
};
  